import { CardContent } from "@mui/material";
import axios from "axios";
import React, { useContext, useState } from "react";
import { Card, Modal } from "react-bootstrap";
import OwlCarousel from "react-owl-carousel";
import { WalletContext } from "../../../CustomHelper/Helper";
import singleFrame from "../../../Assets/Images/Normal-User/Single-frame.png";
import applePayLogo from "../../../Assets/Images/Payment-img/Apple_Pay_logo.png";
import bKashLogo from "../../../Assets/Images/Payment-img/BKash-bKash-Logo.wine.png";
import payoneerLogo from "../../../Assets/Images/Payment-img/Payoneer-Logo.wine.png";
import payPalLogo from "../../../Assets/Images/Payment-img/PayPal-Logo.wine.png";
import shurjopay from "../../../Assets/Images/Payment-img/shurjo-pay.jpeg";
import paytm from "../../../Assets/Images/Payment-img/Paytm_Logo.png";
import strip from "../../../Assets/Images/Payment-img/strip.png";
import "../../../components/CSS/Packages/BuyPackages.css";

import "./PaymentModal.css";
import swal from "sweetalert";
import PaymentSuccessfulModal from "../../Modal/PaymentSuccessfulModal/PaymentSuccessfulModal";
import PaymentUnsuccessfulModal from "../../Modal/PaymentUnsuccessfulModal/PaymentUnsuccessfulModal";
import { usePaytm } from "../../../CustomHooks/usePaytm";
import { useStripePayment } from "../../../CustomHooks/useStripePayment";
import StripeModal from "./StripeModal";
import { useShurjoPay } from "../../../CustomHooks/useShurjoPay";

const PaymentModal1 = (props) => {
  const { shurjoPayMakePayment, shurjoBuffer } = useShurjoPay({
    amount: props?.totalAmount,
    event_type: props?.type,
    event_id: props?.eventId,
    client_ip: "web",
  });

  const { makePaytmPayment, paymentBuffer } = usePaytm({
    amount: props?.totalAmount,
    redirectTo: props?.redirectTo,
    type: props?.type,
    event_id: props?.eventId,
  });
  const {
    stripeMakePayment,
    stripeBuffer,
    clientSecret,
    publicKey,
    error,
    stripeModalShow,
    setStripeModalShow,
  } = useStripePayment({
    amount: props?.totalAmount,
    event_type: props?.type,
    event_id: props?.eventId,
  });

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="modalBody modalBodyStyle">
        <Card style={{ backgroundColor: "#25272b" }} sx={{ minWidth: 275 }}>
          <div className="d-flex justify-content-end p-2">
            <button
              onClick={props.onHide}
              className="closeNotificationDrop text-center"
            >
              X
            </button>
          </div>
          <CardContent>
            <div className="text-center image-middle">
              <img className="singleFrame-style" src={singleFrame} alt="" />
              <h3 className="centered">Payment Method</h3>
            </div>

            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  paddingTop: "50px",
                  paddingBottom: "50px",
                  minHeight: "200px",
                }}
              >
                {paymentBuffer || stripeBuffer || shurjoBuffer ? (
                  <div class="spinner-border text-warning" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                ) : (
                  <>
                    <div
                      className="item"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        makePaytmPayment();
                      }}
                    >
                      <img
                        src={paytm}
                        alt=""
                        className="img-fluid payment-img"
                      />
                    </div>
                    <div
                      className="item"
                      style={{ cursor: "pointer" }}
                      onClick={() => stripeMakePayment()}
                    >
                      <img
                        src={strip}
                        alt=""
                        className="img-fluid payment-img"
                      />
                    </div>
                    <div
                      style={{ cursor: "pointer" }}
                      className="item"
                      onClick={() => shurjoPayMakePayment()}
                    >
                      <img
                        src={shurjopay}
                        alt=""
                        className="img-fluid payment-img"
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </Modal.Body>

      <StripeModal
        show={stripeModalShow}
        onHide={() => setStripeModalShow(false)}
        amount={props?.totalAmount}
        event_id={props?.eventId}
        event_type={props?.type}
        clientSecret={clientSecret}
        publicKey={publicKey}
      />
    </Modal>
  );
};

export default PaymentModal1;
